export const ANIMATE_TIME = 2000

export const DTG_LIST = [
    '201807191200', '201807191800',
    '201807200000', '201807200600', '201807201200', '201807201800',
    '201807210000', '201807210600', '201807211200', '201807211800',
    '201807220000', '201807220600', '201807221200', '201807221800',
]

export const INTERVAL_TIME = ANIMATE_TIME * DTG_LIST.length
